import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Объявляем переводы как объекты
const resources = {
  en: {
    translation: {
      score: "Score",
      gameOver: "Game Over!",
      finalScore: "Final Score",
      playAgain: "Play Again",
      instructions: "Use ↑ and ↓ arrows to move",
      watchAdToContinue: "View ad to continue",
      highScore: "High Score",
      tableScore: "Leaderboard",
      anonim: "Аnonymous",
      menu: "Menu",
      rulesGame: "Rules of the game",
      rulesbasic: "Basic rules:",
      rulesbasicLi1: "The player must exchange adjacent elements to create a row or column of 3 or more identical colors.",
      rulesbasicLi2: "When you create a match of 4 elements vertically or horizontally, a special element with stripes appears.",
      rulesbasicLi3: "If the match consists of 5 elements, a rainbow element appears, which removes all elements of the same color from the field.",
      rulesbasicLi4: "Using elements with stripes (vertical, horizontal or diagonal) removes all elements in the corresponding line.",
      rulesbasicLi5: "The game also features jokers, which help remove elements from the board, like chess pieces (bishop, rook, queen, knight).",
      howToPlay: "How to play:",
      howToPlayLi1: "Click on the elements to swap them.",
      howToPlayLi2: "Collect rows of 3 or more identical elements.",
      howToPlayLi3: "Use special elements and jokers to create chains of removals.",
      close: "Close",
      resetBoard: "Reset board",
      resetBoardAd: "Watch a short ad to reset the board.",
      watchAd: "Watch ad",
      cancel: "Cancel",
      adTime: "Advertising is available via",
      adTimeReset: "Reset board for viewing ads",
      jokers: "Jokers",
    },
  },
  ru: {
    translation: {
      score: "Счёт",
      gameOver: "Игра окончена!",
      finalScore: "Итоговый счёт",
      playAgain: "Играть снова",
      instructions: "Используйте стрелки ↑ и ↓ для движения",
      watchAdToContinue: "Посмотреть рекламу, чтобы продолжить",
      highScore: "Рекорд",
      tableScore: "Таблица лидеров",
      anonim: "Аноним",
      menu: "Меню",
      rulesGame: "Правила игры",
      rulesbasic: "Основные правила:",
      rulesbasicLi1: "Игрок должен обменивать соседние элементы, чтобы создать ряд или колонку из 3 и более одинаковых цветов.",
      rulesbasicLi2: "Когда вы создаете совпадение из 4 элементов по вертикали или горизонтали, появляется специальный элемент с полосами.",
      rulesbasicLi3: "Если совпадение состоит из 5 элементов, появляется элемент-радуга, который удаляет все элементы того же цвета с поля.",
      rulesbasicLi4: "Использование элементов с полосами (вертикальными, горизонтальными или диагональными) удаляет все элементы в соответствии с линиями.",
      rulesbasicLi5: "В игре также есть джокеры, которые помогают удалять элементы на доске, как фигуры шахмат (слон, ладья, ферзь, конь).",
      howToPlay: "Как играть:",
      howToPlayLi1: "Нажимайте на элементы, чтобы обменять их местами.",
      howToPlayLi2: "Собирайте ряды из 3 или более одинаковых элементов.",
      howToPlayLi3: "Используйте специальные элементы и джокеров для создания цепочек удалений.",
      close: "Закрыть",
      resetBoard: "Сбросить доску",
      resetBoardAd: "Посмотрите короткую рекламу, чтобы сбросить доску.",
      watchAd: "Смотреть рекламу",
      cancel: "Отмена",
      adTime: "Реклама доступна через",
      adTimeReset: "Сбросить доску за просмотр рекламы",
      jokers: "Джокеры",
    },
  },
  tr: {
    translation: {
      score: "Skor",
      gameOver: "Oyun Bitti!",
      finalScore: "Son Skor",
      playAgain: "Tekrar Oyna",
      instructions: "Hareket etmek için ↑ ve ↓ tuşlarini kullanin",
      watchAdToContinue: "Devam etmek için reklami izleyin",
      highScore: "En İyi Skor",
      tableScore: "Skor tablosu",
      anonim: "Anonim",
      menu: "Menu",
      rulesGame: "Oyunun kurallari",
      rulesbasic: "Temel kurallar:",
      rulesbasicLi1: "Oyuncu, 3 veya daha fazla ayni renkten oluşan bir satir veya sütun oluşturmak için bitişik öğeleri değiştirmelidir.",
      rulesbasicLi2: "Dikey veya yatay olarak 4 öğeden oluşan bir eşleşme oluşturduğunuzda çizgili özel bir öğe görünür.",
      rulesbasicLi3: "Eşleşme 5 öğeden oluşuyorsa, ayni renkteki tüm öğeleri alandan kaldiran bir gökkuşaği öğesi görünür.",
      rulesbasicLi4: "Çizgili öğelerin (dikey, yatay veya çapraz) kullanilmasi, ilgili satirdaki tüm öğeleri kaldirir.",
      rulesbasicLi5: "Oyunda ayrica satranç taşlari (fil, kale, vezir, at) gibi tahtadaki unsurlarin kaldirilmasina yardimci olan jokerler de bulunur.",
      howToPlay: "Nasil oynanir:",
      howToPlayLi1: "Yerlerini değiştirmek için öğelere tiklayin.",
      howToPlayLi2: "3 veya daha fazla ayni öğeden oluşan satirlari toplayin.",
      howToPlayLi3: "Silme zincirleri oluşturmak için özel öğeler ve jokerler kullanin.",
      close: "Kapali",
      resetBoard: "Karti sifirla",
      resetBoardAd: "Panonuzu sifirlamak için kisa bir reklam izleyin.",
      watchAd: "Reklami izle",
      cancel: "Iptal",
      adTime: "Reklam şu şekilde mevcuttur",
      adTimeReset: "Reklamlari görüntülemek için panoyu sifirlayin",
      jokers: "Jokerler",
    },
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en', // Язык по умолчанию
    detection: {
      order: ['querystring', 'navigator', 'localStorage', 'cookie'], // Приоритет проверки языка
      lookupQuerystring: 'lang', // Ищем параметр lang в URL
      lookupLocalStorage: 'i18nextLng', // Проверка сохраненного языка
      lookupCookie: 'i18next', // Проверка cookie
      caches: ['localStorage', 'cookie'], // Кэширование выбора языка
    },
    interpolation: {
      escapeValue: false, // Отключение экранирования
    },
  });

export default i18n;










